/**
 * LandingCTA — Call-to-Action-Section der Landingpage (W4.2)
 *
 * Großflächiger CTA-Block unterhalb der Feature-Grid.
 */
import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

export function LandingCTA() {
  const { t } = useTranslation('landing')

  return (
    <section className="landing-cta" data-testid="landing-cta">
      <div className="landing-cta__inner">
        <h2 className="landing-cta__headline">
          {t('cta.headline')}
        </h2>
        <p className="landing-cta__sub">
          {t('cta.sub')}
        </p>
        <div className="landing-cta__actions">
          <Link to="/register" className="btn btn-primary btn-lg">
            {t('cta.start')}
          </Link>
          <Link to="/login" className="btn btn-lg">
            {t('cta.alreadyRegistered')}
          </Link>
        </div>
      </div>
    </section>
  )
}
